import { render, staticRenderFns } from "./ClassProduct.vue?vue&type=template&id=0c52f754&"
import script from "./ClassProduct.vue?vue&type=script&lang=js&"
export * from "./ClassProduct.vue?vue&type=script&lang=js&"
import style0 from "./ClassProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports